module.exports = {"451481100":"凭祥镇","451481101":"友谊镇","451481102":"上石镇","451481103":"夏石镇","451481400":"广西凭祥综合保税区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451481.json
// module id = 2006
// module chunks = 0